<template>
    <div class="card">
        <div class="card-body">
        <h4 class="card-title">{{$t('order.bijlages')}}({{attachments ? attachments.length : 0}})</h4>
            <b-table show-empty stacked="lg" :items="attachments" :fields="fields" :empty-text="getEmptyText(count)" :busy="count == -1">
                <template v-slot:cell(name)="row">
                    <b-button variant="link" @click.stop="downloadAttachment(row.item)">
                        {{row.item.name}}
                    </b-button>
                </template>
                <template v-slot:table-busy>
                    <PreLoader/>
                </template>
                <template v-slot:cell(actions)="row">
                    <delete title="Bijlage" 
                    :noRedirect="true" 
                    :hideText="true" 
                    :id="row.item.id" 
                    :entityId="row.item.entityId"
                    namespace="shared" 
                    resource="attachments" />
                </template>
            </b-table>
            <b-form @submit="onSubmit" autocomplete="off" class="no-printable">
                <b-row>
                    <b-col lg="12" xl="8">
                        <b-form-file v-if="canUpload" v-model="command.content" :placeholder="$t('order.bladeren')" />
                    </b-col>
                    <b-col lg="12" xl="4" v-if="command.content && command.content.size > 0" class="my-1">
                        <b-button type="submit" class="pull-right" variant="themecolor">Uploaden</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
    </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'
import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';
//Import command
import Command from './command'

export default {
    name: 'attachments',
    components: {PreLoader},
    data () {
      return {
        count: -1,
        canUpload: true,
        command: new Command(),
      }
    },
    props: ['entityId'],
    computed: {
        fields() {
            return [
            { key: 'name', label: this.$i18n.t('datatables.naam'), sortable: true },
            { key: 'actions', label: this.$i18n.t('datatables.acties') }
        ]
    },
      ...mapGetters ('shared',['attachments'])
    },
    methods: {
        ...mapActions('shared',['getEntities','downloadAttachment','uploadAttachment']),
        onSubmit(event) {
            event.preventDefault();
            var vm = this;

            var command = new Command()
            command.entityId = vm.entityId;
            command.name = vm.command.content.name;
            command.content = vm.command.content;

            vm.uploadAttachment(command)
            .then(()=> {
                    vm.canUpload = false
                    vm.$nextTick(() => {
                        vm.canUpload = true
                    });
            })
            .catch(()=> {
                vm.$swal(this.$i18n.t('delete.mislukt'), `${this.$i18n.t('delete.debijlagekonnietwordenaangemaakt')}`, this.$i18n.t('delete.error'));
            });
        },
        getEmptyText,
    },
    created() {
        var vm = this;
        vm.getEntities({
            resource: 'attachments',
            entityId: vm.entityId
        })
        .then((list) => {
            vm.count = list.length;
        });
    }
}
</script>